import React from 'react'

import { getDateSignedBoxSizings } from '../SignDocumentFlow.utils'

interface DateSignedBoxesProps {
  date: string
  width: number
  height: number
}

function Box({
  value,
  width,
  height,
  fontSize,
}: {
  value: string
  width: number
  height: number
  fontSize: number
}) {
  return (
    <div
      className="flex items-center justify-center"
      style={{
        width: `${width}px`,
        height: `${height}px`,
        fontSize: `${fontSize}px`,
        lineHeight: `${height}px`,
      }}
    >
      {value}
    </div>
  )
}

export const DateSignedBoxes: React.FC<DateSignedBoxesProps> = ({
  date, // YYYY-MM-DD
  width,
  height,
}) => {
  const { boxWidth, boxHeight, sectionSpacingWidth, boxSpacingWidth } =
    getDateSignedBoxSizings({ width, height })

  // Split date into parts if we have a value
  const dateParts = date.split('-') || []
  const day = dateParts[2]?.padStart(2, '0') || ''
  const month = dateParts[1]?.padStart(2, '0') || ''
  const year = dateParts[0] || ''

  return (
    <div
      className="flex items-center justify-between h-full"
      style={{ width: `${width}px`, gap: `${sectionSpacingWidth}px` }}
    >
      {/* Day */}
      <div className="flex" style={{ gap: `${boxSpacingWidth}px` }}>
        {[...Array(2)].map((_, i) => (
          <Box
            key={`day-${i}`}
            value={day[i] || ''}
            width={boxWidth}
            height={boxHeight}
            fontSize={12}
          />
        ))}
      </div>

      {/* Month */}
      <div className="flex" style={{ gap: `${boxSpacingWidth}px` }}>
        {[...Array(2)].map((_, i) => (
          <Box
            key={`month-${i}`}
            value={month[i] || ''}
            width={boxWidth}
            height={boxHeight}
            fontSize={12}
          />
        ))}
      </div>

      {/* Year */}
      <div className="flex" style={{ gap: `${boxSpacingWidth}px` }}>
        {[...Array(4)].map((_, i) => (
          <Box
            key={`year-${i}`}
            value={year[i] || ''}
            width={boxWidth}
            height={boxHeight}
            fontSize={12}
          />
        ))}
      </div>
    </div>
  )
}
